import React from 'react';
import { Snackbar, Alert, Typography, Stack, Box, Fade } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setSuccessSnack } from '../../Reducers/snackSuccess';
import { CheckCircleRounded } from '@mui/icons-material';

const SuccessSnack = () => {

  const dispatch = useDispatch();
  const title = useSelector((state) => state.success.title);
  const body = useSelector((state) => state.success.body);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    dispatch(setSuccessSnack({title: null, body: null}));
  };

  return (
    <Snackbar
  open={title != null}
  autoHideDuration={6000}
  onClose={handleClose}
  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
  TransitionComponent={Fade} // Or use Slide for a slide-up effect
  sx={{
    '&.MuiSnackbar-root': {
      bottom: { xs: 16, sm: 24 }, // Responsive positioning
      right: { xs: 16, sm: 24 },
    }
  }}
>
  <Alert 
    onClose={handleClose} 
    severity="success" 
    variant="filled" // Or "outlined" for softer look
    sx={{ 
      width: '100%',
      maxWidth: 400,
      boxShadow: 3,
      borderRadius: 1,
      '& .MuiAlert-icon': {
        alignItems: 'center',
        fontSize: '1.5rem'
      },
      '& .MuiAlert-message': {
        py: 1,
        width: '100%'
      }
    }}
    iconMapping={{
      success: <CheckCircleRounded fontSize="inherit" />
    }}
  >
    <Stack spacing={0.5}>
      <Typography 
        fontWeight={600} 
        variant="subtitle1"
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}
      >
        {title}
      </Typography>
      <Typography 
        variant="body2"
        sx={{
          color: theme => theme.palette.mode === 'light' ? 
            'rgba(255,255,255,0.8)' : 
            'rgba(0,0,0,0.7)'
        }}
      >
        {body}
      </Typography>
      
    </Stack>
  </Alert>
</Snackbar>
  );
};

export default SuccessSnack;
